import axios from 'axios'

const API_ENDPOINT = window.config.ssURL + 'stores'

export default {
    fetchStores(search) {
        return axios.get(API_ENDPOINT + '/list/' + search)
    },
}
